module.exports = __webpack_public_path__ + "static2023-4-17/img/pay.3fe0738d.png";